import useUmami from '@/lib/umami';
import { MoreOutlined } from '@ant-design/icons';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import type { CSSProperties, FC } from 'react';
import { Dropdown, type MenuProps } from '..';
import { Button } from './Button';

interface MoreButtonProps
  extends Pick<MenuProps, 'items' | 'onClick' | 'disabled'> {
  isBorder?: boolean;
  size?: SizeType;
  style?: CSSProperties;
}

/**
 * MoreButton
 * When used in a table, it does not affect row selection.
 */
export const MoreButton: FC<MoreButtonProps> = ({
  isBorder = true,
  size = 'middle',
  items,
  onClick,
  style,
  disabled,
}) => {
  const umami = useUmami();

  return items?.length ? (
    <Dropdown
      placement="bottomRight"
      menu={{
        items,
        onClick: (e) => {
          // avoid table row selection
          e.domEvent.stopPropagation();
          onClick?.(e);
          umami.event(e.domEvent.currentTarget.textContent || e.key);
        },
        className: 'dd-privacy-allow',
      }}
      trigger={['click']}
      disabled={disabled}
    >
      <Button
        size={size}
        icon={<MoreOutlined />}
        style={{
          borderWidth: isBorder ? undefined : 0,
          boxShadow: isBorder ? undefined : 'none',
          ...style,
        }}
      />
    </Dropdown>
  ) : null;
};
